export default {"src":"/_next/static/media/allWatchesHeaderIcon.9548b0df.svg","height":19,"width":14,"blurWidth":0,"blurHeight":0};